import styled from 'styled-components';
import { darkgrey, reviewSubtitle } from 'styles/Colors';

export const BpPlaysGridWrapper = styled.div`
  .data-grid {
    height: calc(100vh - 95px);
    .header-content {
      font-family: Lato;
      margin-top: 5px;
      .title {
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 0.44px;
        color: ${darkgrey};
      }
      .subtitle {
        font-size: 14px;
        letter-spacing: 0.39px;
        color: ${reviewSubtitle};
      }
    }
  }
`;
